// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Ttrm20yJkUCvVi {\n  background: #EBECF0;\n}\n.LtbSQ1JzN14usb {\n  margin-right: 8px;\n}\n.LtbSQ1JzN14usb:visited,\n.LtbSQ1JzN14usb:active {\n  outline: none;\n}\n.LtbSQ1JzN14usb:focus {\n  outline: -webkit-focus-ring-color auto 1px;\n}\n.LtbSQ1JzN14usb .icon-template-card {\n  margin-right: 0;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": "Ttrm20yJkUCvVi",
	"cardTemplateButton": "LtbSQ1JzN14usb"
};
export default ___CSS_LOADER_EXPORT___;
